// 粘性计时器功能（优先级版本）
(function() {
  //console.log('[Sticky Timer] 脚本开始执行');
  
  // 检查是否为移动设备
  function isMobile() {
    const width = window.innerWidth;
    const userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const result = width <= 768 || userAgent;
    return result;
  }
  
  // 存储是否已经初始化的标志
  let isInitialized = false;
  let searchAttempts = 0;
  let searchInterval = null;
  let currentStickyElement = null; // 记录当前悬停的元素
  
  // 主要功能函数
  function initStickyTimer() {
    //console.log('[Sticky Timer] initStickyTimer 函数开始执行');
    
    // 检查是否为移动设备
    if (!isMobile()) {
      //console.log('[Sticky Timer] 不是移动设备，功能停止');
      return false;
    }
    
    //console.log('[Sticky Timer] 是移动设备，继续执行');
    
    // 优先查找 timesact-button
    let timerContainer = document.querySelector('.timesact-button');
    let containerType = 'timesact-button';
    
    // 如果没找到 timesact-button，则查找 product-form__buttons
    if (!timerContainer) {
      timerContainer = document.querySelector('.product-form__buttons');
      containerType = 'product-form__buttons';
    }
    
    if (!timerContainer) {
      //console.log(`[Sticky Timer] 第 ${searchAttempts + 1} 次查找，未找到任何元素`);
      return false;
    }
    
    //console.log(`[Sticky Timer] 找到元素！类型: ${containerType}`, timerContainer);
    
    // 如果当前已经对某个元素初始化了，检查是否需要切换
    if (isInitialized && currentStickyElement) {
      // 如果当前是 product-form__buttons，但现在找到了 timesact-button
      if (currentStickyElement.classList.contains('product-form__buttons') && 
          containerType === 'timesact-button') {
        //console.log('[Sticky Timer] 发现更高优先级的元素，准备切换');
        // 清理当前的悬停效果
        cleanupStickyEffect();
        isInitialized = false;
        currentStickyElement = null;
      } else if (currentStickyElement === timerContainer) {
        // 如果是同一个元素，不需要重新初始化
        //console.log('[Sticky Timer] 元素已初始化，跳过');
        return true;
      }
    }
    
    // 标记为已初始化
    isInitialized = true;
    currentStickyElement = timerContainer;
    
    // 获取元素的原始位置信息
    const rect = timerContainer.getBoundingClientRect();
    const originalPosition = rect.top + window.pageYOffset;
    const stickyTop = 110; // 悬停位置距离顶部的高度
    
    // 创建占位符元素，防止内容跳动
    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.className = 'sticky-timer-placeholder';
    timerContainer.parentNode.insertBefore(placeholder, timerContainer);
    
    // 存储原始样式
    const computedStyle = window.getComputedStyle(timerContainer);
    const originalStyles = {
      position: timerContainer.style.position || computedStyle.position,
      top: timerContainer.style.top || computedStyle.top,
      left: timerContainer.style.left || computedStyle.left,
      right: timerContainer.style.right || computedStyle.right,
      width: timerContainer.style.width || computedStyle.width,
      zIndex: timerContainer.style.zIndex || computedStyle.zIndex
    };
    
    let isSticky = false;
    let scrollEventCount = 0;
    
    // 滚动处理函数
    function handleScroll() {
      scrollEventCount++;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldStick = scrollTop > (originalPosition - stickyTop);
      
      if (shouldStick && !isSticky) {
        //console.log('[Sticky Timer] 激活粘性定位');
        
        // 设置为粘性定位
        const rect = timerContainer.getBoundingClientRect();
        
        // 设置占位符的高度
        placeholder.style.height = rect.height + 'px';
        placeholder.style.display = 'block';
        
        // 应用粘性样式
        timerContainer.style.position = 'fixed';
        timerContainer.style.top = stickyTop + 'px';
        timerContainer.style.left = '0';
        timerContainer.style.right = '0';
        timerContainer.style.width = '100%';
        timerContainer.style.zIndex = '999';
        
        // 添加一个类名方便调试
        timerContainer.classList.add('is-sticky');
        
        isSticky = true;
        
      } else if (!shouldStick && isSticky) {
        //console.log('[Sticky Timer] 取消粘性定位');
        
        // 恢复原始样式
        timerContainer.style.position = originalStyles.position;
        timerContainer.style.top = originalStyles.top;
        timerContainer.style.left = originalStyles.left;
        timerContainer.style.right = originalStyles.right;
        timerContainer.style.width = originalStyles.width;
        timerContainer.style.zIndex = originalStyles.zIndex;
        
        // 隐藏占位符
        placeholder.style.display = 'none';
        
        // 移除调试类名
        timerContainer.classList.remove('is-sticky');
        
        isSticky = false;
      }
    }
    
    // 保存清理函数到元素上
    timerContainer._stickyCleanup = function() {
      if (isSticky) {
        timerContainer.style.position = originalStyles.position;
        timerContainer.style.top = originalStyles.top;
        timerContainer.style.left = originalStyles.left;
        timerContainer.style.right = originalStyles.right;
        timerContainer.style.width = originalStyles.width;
        timerContainer.style.zIndex = originalStyles.zIndex;
        placeholder.style.display = 'none';
        timerContainer.classList.remove('is-sticky');
      }
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }
      window.removeEventListener('scroll', requestTick);
    };
    
    // 添加滚动事件监听器
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // 监听窗口大小变化
    window.addEventListener('resize', function() {
      if (!isMobile()) {
        // 如果不再是移动设备，移除粘性效果
        if (isSticky) {
          timerContainer.style.position = originalStyles.position;
          timerContainer.style.top = originalStyles.top;
          timerContainer.style.left = originalStyles.left;
          timerContainer.style.right = originalStyles.right;
          timerContainer.style.width = originalStyles.width;
          timerContainer.style.zIndex = originalStyles.zIndex;
          placeholder.style.display = 'none';
          isSticky = false;
        }
        window.removeEventListener('scroll', requestTick);
      } else {
        // 如果变成移动设备，重新添加监听器
        window.addEventListener('scroll', requestTick, { passive: true });
      }
    });
    
    // 初始检查
    handleScroll();
    
    //console.log(`[Sticky Timer] ${containerType} 初始化完成`);
    return true; // 返回 true 表示初始化成功
  }
  
  // 清理当前的悬停效果
  function cleanupStickyEffect() {
    if (currentStickyElement && currentStickyElement._stickyCleanup) {
      //console.log('[Sticky Timer] 清理当前悬停效果');
      currentStickyElement._stickyCleanup();
      delete currentStickyElement._stickyCleanup;
    }
  }
  
  // 持续查找函数
  function startContinuousSearch() {
    //console.log('[Sticky Timer] 开始持续查找目标元素');
    
    // 立即尝试一次
    searchAttempts++;
    if (initStickyTimer()) {
      //console.log(`[Sticky Timer] 第 ${searchAttempts} 次查找成功`);
      // 即使找到了 product-form__buttons，也继续查找，以防 timesact-button 后出现
      if (currentStickyElement && currentStickyElement.classList.contains('timesact-button')) {
        //console.log('[Sticky Timer] 找到最高优先级元素，停止查找');
        if (searchInterval) {
          clearInterval(searchInterval);
        }
        return;
      }
    }
    
    // 设置定时器持续查找
    searchInterval = setInterval(function() {
      searchAttempts++;
      
      // 尝试初始化
      if (initStickyTimer()) {
        // 如果找到了 timesact-button，停止查找
        if (currentStickyElement && currentStickyElement.classList.contains('timesact-button')) {
          //console.log(`[Sticky Timer] 第 ${searchAttempts} 次查找到 timesact-button，停止查找`);
          clearInterval(searchInterval);
          searchInterval = null;
          return;
        }
      }
      
      // 超过100次查找后降低频率
      if (searchAttempts === 100) {
        //console.log('[Sticky Timer] 已查找100次，降低查找频率到每2秒一次');
        clearInterval(searchInterval);
        searchInterval = setInterval(function() {
          searchAttempts++;
          if (initStickyTimer()) {
            if (currentStickyElement && currentStickyElement.classList.contains('timesact-button')) {
              //console.log(`[Sticky Timer] 第 ${searchAttempts} 次查找到 timesact-button，停止查找`);
              clearInterval(searchInterval);
              searchInterval = null;
            }
          }
        }, 2000); // 改为每2秒查找一次
      }
      
      // 超过200次后停止查找
      if (searchAttempts >= 200) {
        //console.log('[Sticky Timer] 已查找200次，停止查找');
        clearInterval(searchInterval);
        searchInterval = null;
      }
      
    }, 500); // 每500毫秒查找一次
  }
  
  // 使用 MutationObserver 监听 DOM 变化（更高效的方案）
  function setupMutationObserver() {
    //console.log('[Sticky Timer] 设置 MutationObserver');
    
    const observer = new MutationObserver(function(mutations) {
      // 检查是否有新增的目标元素
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // 元素节点
              // 检查 timesact-button（高优先级）
              if ((node.classList && node.classList.contains('timesact-button')) ||
                  (node.querySelector && node.querySelector('.timesact-button'))) {
                //console.log('[Sticky Timer] MutationObserver 发现 timesact-button');
                initStickyTimer();
                // 如果找到 timesact-button，停止观察
                if (currentStickyElement && currentStickyElement.classList.contains('timesact-button')) {
                  observer.disconnect();
                }
              }
              // 检查 product-form__buttons（低优先级）
              else if (!currentStickyElement && 
                       ((node.classList && node.classList.contains('product-form__buttons')) ||
                        (node.querySelector && node.querySelector('.product-form__buttons')))) {
                //console.log('[Sticky Timer] MutationObserver 发现 product-form__buttons');
                initStickyTimer();
              }
            }
          });
        }
      }
    });
    
    // 观察整个 body 的变化
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // 10分钟后停止观察
    setTimeout(function() {
      if (!currentStickyElement || !currentStickyElement.classList.contains('timesact-button')) {
        //console.log('[Sticky Timer] MutationObserver 10分钟超时，停止观察');
        observer.disconnect();
      }
    }, 600000);
  }
  
  // 主执行函数
  function main() {
    //console.log('[Sticky Timer] DOM 状态:', document.readyState);
    
    // 确保 body 存在
    if (!document.body) {
      //console.log('[Sticky Timer] document.body 不存在，等待 DOMContentLoaded');
      document.addEventListener('DOMContentLoaded', main);
      return;
    }
    
    // 启动持续查找
    startContinuousSearch();
    
    // 同时设置 MutationObserver（如果浏览器支持）
    if (typeof MutationObserver !== 'undefined') {
      setupMutationObserver();
    }
  }
  
  // 开始执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    // 使用 setTimeout 确保其他脚本已经执行
    setTimeout(main, 100);
  }
})();